import { UseFormReturn } from 'react-hook-form';
import { useLanguage } from '@/hooks/useLanguage';

interface ConditionalQuestionsStepProps {
  form: UseFormReturn<any>;
}

const ConditionalQuestionsStep = ({ form }: ConditionalQuestionsStepProps) => {
  const { t } = useLanguage();
  const service = form.watch('service');

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-2xl font-bold mb-2">Service-Specific Questions</h3>
        <p className="text-muted-foreground">Please provide additional information about your {service} case</p>
      </div>

      <div className="bg-muted p-6 rounded-lg text-center">
        <p className="text-lg font-medium mb-2">Service-specific questions for {service}</p>
        <p className="text-sm text-muted-foreground">
          This section will contain conditional questions based on the selected service type.
          Questions will be added in subsequent development phases.
        </p>
      </div>
    </div>
  );
};

export default ConditionalQuestionsStep;
